// Dragspel för topplistorna i statistiken. Samma beteende som FAQ-listan, men utan ankarlänkar.
// Gör bara något på element märkta med data-breaks-ranking-list.

import { AccordionSelectors, initAccordion } from "./accordion";

const SELECTORS: AccordionSelectors = {
  item: ".ranking-list__item",
  trigger: ".ranking-list__trigger",
};

export function initRankingLists(root: ParentNode = document): void {
  root
    .querySelectorAll<HTMLElement>("[data-breaks-ranking-list]")
    .forEach((list) => initAccordion(list, SELECTORS));
}
